import Vue from 'vue'
import VueSession from "vue-session"
Vue.use(VueSession, {
  persist: true // data stored in the session may persist between tabs and browser instances
})